import { Component, OnInit,Input, Output, OnChanges, SimpleChanges, EventEmitter,AfterViewInit } from '@angular/core';

// Representa un vehículo
export interface Vehiculo {
  nombre: string;
  imei: string;
  icon: string;
  nameoperation: string;
}

// Representa el historial o cambio
export interface HistorialCambio {
  fecha_desde: string;    // Formato ISO: "2025-06-19T00:00:00-05:00"
  fecha_hasta: string;    // Formato ISO
  tzCustom: string;       // Ejemplo: "- 5 hour"
  tzOffset: string;       // Ejemplo: "-05:00"
  tzPHP: string;          // Ejemplo: "+5 hours"
  user_id: string;        // Puede cambiar a number si se maneja como tal
  vehiculos?: Vehiculo[];  // Lista de vehículos asociados al cambio
}

export interface IGeofenceInformation {
  bol_eliminado: boolean;
  bol_es_grupo: boolean;
  bol_limite_velocidad_activo: string;
  bol_mostrar: string;
  bol_mostrar_nombre: string;
  bol_opt_avanzadas: boolean;
  bol_personalizado: boolean;
  bol_sin_relleno: boolean;
  dbl_area: string;
  dbl_radio: string;
  enm_tipo_linea: string;
  geo_coordenadas: string;
  geo_tags: string;
  grupo_convoy_id: number | null;
  int_categoria: number;
  int_limite_velocidad_0: number;
  int_limite_velocidad_1: number;
  int_limite_velocidad_2: number;
  int_limite_velocidad_3: number;
  operation_grupo_id: number | null;
  tag_name_color: string;
  tag_name_font_size: number;
  txt_descripcion: string | null;
  usuario_id: number;
  var_color: string;
  var_nombre: string;
}


export interface IHistorialTramasInformation {
 fechaDesde: string;
  fechaHasta: string;
  tzOffset: string;
  userId: string;
  vehiculos: HistorialTramasVehiculo[];
}

export interface HistorialTramasVehiculo {
  nombre: string;
  imei: string;
  icon: string;
  nameoperation: string;
}

@Component({
  selector: 'app-auditdetail',
  templateUrl: './auditdetail.component.html',
  styleUrls: ['./auditdetail.component.scss']
})
export class AuditdetailComponent implements AfterViewInit, OnChanges{

  @Input('display') display: boolean = false;
  @Input() activity?: any ;
  @Input() ip: string = "";
  @Input() properties: string = "";
  @Input() subject_type: string = "";
  @Input() message: string = "";

  @Output() onHideEvent = new EventEmitter<boolean>();


  public data : any;

  attributes:any = {};
  old:any = {};
  display_old: boolean = false;
  display_new: boolean = false;

  constructor() { 
  }

  ngAfterViewInit(): void {
    
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['properties'] || changes['subject_type'] ||  changes['activity']) {
      this.onShow();
    }
  }


  onHide(){
    this.data = {}
    this.onHideEvent.emit(false);
    this.attributes = {};
    this.old = {};
    this.display_new = false;
    this.display_old= false;
  }

  onShow(){
    this.data = {}
    
    let properties_json = JSON.parse(this.properties)
    this.activity.username = this.extraerUsuario(this.activity.description)
    
    // Lista de tipos que usan directamente los attributes
    const usesAttributes = [
      "API_postgres/Driver/create",
      "API_postgres/Driver/update",
      "API_postgres/Driver/delete",
      "UserTracker",
      "GroupConvoy",
      "Zone",
      "CircularZone",
      "EventUser"
    ];

    switch (this.subject_type) {
      case "HistorialTramas":
        this.data = {
          ...properties_json,
          vehiculos: JSON.parse(properties_json.vehiculos || "[]")
        };
        break;

      default:
        this.data = usesAttributes.includes(this.subject_type)
          ? properties_json.attributes
          : properties_json;
        break;
    }

    
    if(this.attributes){
      this.display_new = true;
    }
    if(this.old){
      this.display_old= true;
    }
  }

  removeIp(description: string): string {
    // Regex para buscar IP en el formato de "desde la IP XXX.XXX.XXX.XXX"
    return description.replace(/desde la IP <span class="text-primary">\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}<\/span>/, '');
  }
  extraerUsuario(htmlString: string): string | null {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlString;
    const userSpan = tempDiv.querySelector('span.text-primary');
    return userSpan?.textContent?.trim() ?? null;
  }
}
